import React from 'react';
import { WhatsAppButton } from './WhatsAppButton';
export function FinalCTA() {
  return <section className="py-24 bg-primary relative overflow-hidden" data-id="element-49">
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-10" data-id="element-50">
        <svg className="h-full w-full" xmlns="http://www.w3.org/2000/svg" data-id="element-51">
          <defs data-id="element-52">
            <pattern id="diagonal-stripes-cta" width="40" height="40" patternUnits="userSpaceOnUse" patternTransform="rotate(-45)" data-id="element-53">
              <rect width="2" height="40" fill="currentColor" data-id="element-54" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#diagonal-stripes-cta)" data-id="element-55" />
        </svg>
      </div>

      <div className="container mx-auto px-4 relative z-10 text-center" data-id="element-56">
        <div className="max-w-4xl mx-auto" data-id="element-57">
          <h2 className="text-white font-heading font-bold mb-6" data-id="element-58">
            No dejés que un equipo parado siga{' '}
            <span className="text-accent" data-id="element-59">COSTANDOTE PLATA</span>
          </h2>

          <p className="text-subtitleDark text-lg mb-12 max-w-2xl mx-auto" data-id="element-60">
            La inspección técnica no tiene costo. Contactanos ahora y en menos
            de 24hs tenés respuesta.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-61">
            <WhatsAppButton href="https://wa.me/5491161279601?text=Hola%20Ramón%2C%20quiero%20agendar%20una%20inspección%20técnica%20para%20mi%20equipo" text="Hablar con Ramón" variant="primary" className="w-full sm:w-auto" data-id="element-62" />
            <WhatsAppButton href="https://wa.me/5491121707246?text=Hola%20Marcelo%2C%20quiero%20agendar%20una%20inspección%20técnica%20para%20mi%20equipo" text="Hablar con Marcelo" variant="secondary" className="w-full sm:w-auto" data-id="element-63" />
          </div>
        </div>
      </div>
    </section>;
}